export const ATLAS_CONNECTED_QUERY_PARAM = "ac";
export const ATLAS_CONNECTED_QUERY_PARAM_VALUE = "1";

export const PROPERTIES_PANE_STATE_PARAM = "pane";
